var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"store-button",class:_vm.buttonClass,on:{"click":function($event){return _vm.handleClick(_vm.version)}}},[(_vm.buttonText)?_c('img',{staticClass:"button-text",attrs:{"src":_vm.buttonText}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }